import { type IconDefinition } from '@fortawesome/fontawesome-common-types'
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faPinterest,
  faTiktok,
  faYoutube,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  NavigationMenuItem,
  NavigationMenuLink,
} from '@radix-ui/react-navigation-menu'
import {
  type AbstractIntlMessages,
  useMessages,
  useTranslations,
} from 'next-intl'
import Link from 'next/link'
import { cn } from 'utils/cn'

const icons: Record<string, IconDefinition> = {
  facebook: faFacebookF,
  instagram: faInstagram,
  linkedin: faLinkedinIn,
  tiktok: faTiktok,
  youtube: faYoutube,
  pinterest: faPinterest,
  whatsapp: faWhatsapp,
}

export const MobileFooter = () => {
  const t = useTranslations('Footer.SocialMediaLinks')
  const messages = useMessages() as AbstractIntlMessages & {
    Footer: { SocialMediaLinks: AbstractIntlMessages }
  }

  return (
    <div className='bg-primary-900 text-body-xl flex h-[90px] items-center justify-center rounded-t-2xl px-4 pt-1 text-white sm:h-full'>
      <ul className='flex gap-3'>
        {Object.keys(messages.Footer.SocialMediaLinks).map((key) => (
          <NavigationMenuItem key={key}>
            <NavigationMenuLink asChild>
              <Link
                className={cn('flex h-10 w-10 items-center justify-center')}
                href={t(`${key}.link`)}
                target='_blank'
                title={t(`${key}.title`)}
                onPointerDown={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                }}
                prefetch={false}
              >
                <FontAwesomeIcon icon={icons[key]} title={t(`${key}.title`)} />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
        ))}
      </ul>
    </div>
  )
}
